import React, {Component} from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from 'react-facebook-pixel';
import {salesChannelRegister} from "../../services/salesChannelRegister";
import ModalImageSize from "../signup-image/component";
import ModalCropp from "../../components/modal-cropp/component";
import {BeatLoader} from "react-spinners";
import ModalVideoDimension from "../../components/modal-videodimension/component";
import {themeRegister} from "../../services/themeRegister";
import {videoRegisterNew} from "../../services/videoRegisterNew";

class SignUpThemeCustom extends Component {

    constructor(props) {
        super(props);
        this.state = {
            video: null,
            slides: []
        };
    };

    componentWillMount() {
        window.scrollTo(0, 0);

        //GOOGLE ANALYTICS
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactGA.pageview('/signup/theme-custom');
            ReactGA4.send({ hitType: "pageview", page: "/signup/theme-custom" });
        }

        //FACEBOOK PIXEL
        if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
            ReactPixel.pageView();
        }

        themeRegister.setTheme("custom");

    }

    update = {};

    functions = {
        uploadVideo: (e) => {
            if (e.target.files && e.target.files.length > 0) {
                if(e.target.files[0].size > 5999000){
                    this.setState({size_modal: true});
                }else{
                    this.setState({temp_src: e.target.files[0]}, () => {
                        let video_object = {
                            url: null,
                            date: Math.floor(Math.random() * 999999999999999999999),
                            isAnalyzing: true
                        };
                        this.state.video = video_object;
                        this.setState({video: this.state.video}, () => {
                            let files = new FormData();
                            files.append('file', this.state.temp_src);
                            dataRegister.uploadVideo(files).then((response) => {
                                this.state.video.url = response.url;
                                this.state.video.thumbnail = response.thumbnail;
                                this.state.video.isAnalyzing = false;
                                this.setState({
                                    video: this.state.video
                                }, () => {
                                    videoRegisterNew.setCustom(this.state.video.url, this.state.video.thumbnail);
                                });
                            }, (error) => {
                                this.setState({
                                    dimensions_modal: true,
                                    video: null
                                })
                            });
                        })
                    });
                }
            }
        },
        uploadSlide: (e) => {
            if (e.target.files && e.target.files.length > 0) {
                if(e.target.files[0].size > 5999000){
                    this.setState({size_modal: true});
                }else{
                    this.setState({temp_src: e.target.files[0]}, () => {
                        let image_object = {
                            url: null,
                            date: Math.floor(Math.random() * 999999999999999999999),
                            isAnalyzing: true
                        };
                        this.state.slides.push(image_object);
                        this.setState({slides: this.state.slides}, () => {
                            let files = new FormData();
                            files.append('file', this.state.temp_src);
                            dataRegister.createSlide(files).then((response) => {
                                for(let i = 0; i < this.state.slides.length; i++){
                                    if(this.state.slides[i].date === image_object.date){
                                        this.state.slides[i].url = response.url;
                                        this.state.slides[i].isAnalyzing = false;
                                        break;
                                    }
                                }
                                this.setState({
                                    slides: this.state.slides
                                });
                            }, (error) => {});
                        })
                    });
                }
            }
        },
        removeVideo: (item) => {
            this.setState({
                video: null
            });
        },
        removeSlide: (item) => {
            this.state.slides = this.state.slides.filter((slide) => {return slide.date !== item.date});
            this.setState({
                slides: this.state.slides
            });
        },
        next: () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get("name")+ "/signup/ads");
        },
        back: () => {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/" + salesChannelRegister.get("name")+ "/signup/business");
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-theme-custom", item);
        },
        video: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div className={cx(Styles.imagesContainerItemPadding)}>
                        {
                            item.isAnalyzing &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div className={Styles.imagesContainerItemOverlayText}>
                                    <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                                    <div className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_6")}</div>
                                </div>
                            </div>
                        }
                        {
                            item.url && !item.isAnalyzing &&
                            <div className={Styles.imagesContainerItemInner}>
                                <video className={Styles.imagesContainerItemVideo} controls poster={this.state.video.thumbnail} muted={false} loop={false} autoPlay={false}>
                                    <source src={this.state.video.url} type="video/mp4"/>
                                </video>
                            </div>
                        }
                        {
                            !item.isAnalyzing &&
                            <div onClick={() => this.functions.removeVideo(item)} className={Styles.imagesContainerItemRemove}>
                                <img className={Styles.imagesContainerItemRemoveItem} src={require('../../assets/images/AB_cross_bold.png')}/>
                            </div>
                        }
                    </div>
                </div>
            )
        },
        slide: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    <div className={cx(Styles.imagesContainerItemPadding)}>
                        {
                            item.isAnalyzing &&
                            <div className={Styles.imagesContainerItemOverlay}>
                                <div className={Styles.imagesContainerItemOverlayText}>
                                    <BeatLoader size={20} color={'#41CBC7'} loading={true}/>
                                    <div className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_5")}</div>
                                </div>
                            </div>
                        }
                        {
                            item.url && !item.isAnalyzing &&
                            <div className={cx(Styles.imagesContainerItemInner)}>
                                <div style={{backgroundImage: "url(" + item.url + ")"}} className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)}/>
                            </div>
                        }
                        {
                            !item.isAnalyzing &&
                            <div onClick={() => this.functions.removeSlide(item)} className={Styles.imagesContainerItemRemove}>
                                <img className={Styles.imagesContainerItemRemoveItem} src={require('../../assets/images/AB_cross_bold.png')}/>
                            </div>
                        }
                    </div>
                </div>
            )
        },
    };

    render() {
        return (
            <div>
                <HeaderSignupOne history={this.props.history} view={"signup"} props={this.props}/>
                {
                    this.state.size_modal &&
                    <ModalImageSize setLeave={(value) => this.setState({size_modal: false})}/>
                }
                {
                    this.state.dimensions_modal &&
                    <ModalVideoDimension setLeave={(value) => this.setState({dimensions_modal: false})}/>
                }
                <div className={Styles.containerOuter}>
                    <div className={Styles.container}>
                        <div className={Styles.title}>
                            <div>
                                {this.renders.text("item_1")}
                            </div>
                        </div>
                        <div className={Styles.optionsContainer}>
                            <div className={Styles.optionsContainerSectionTitle}>
                                {this.renders.text("item_2")}
                            </div>
                            <div className={Styles.optionsContainerItems}>
                                <div className={Styles.optionsContainerItemsPlus}>
                                    <div className={Styles.optionsContainerItemsPlusInner}>
                                        <div className={Styles.optionsContainerItemsPlusInnerPlus}>
                                            +
                                        </div>
                                    </div>
                                    {
                                        !this.state.video &&
                                        <input ref="uploadVideoFile" onClick={() => this.refs.uploadVideoFile.value = null} onChange={(e) => this.functions.uploadVideo(e)} type={"file"} accept={"video/mp4"}  className={Styles.optionsContainerItemsPlusInnerUpload}/>
                                    }
                                </div>
                                {
                                    this.state.video &&
                                    this.renders.video(this.state.video)
                                }
                                {
                                    this.state.video &&
                                    <div className={cx(Styles.imagesContainerItem, Styles.imagesContainerItemPlaceholder)}></div>
                                }
                                {
                                    this.state.video &&
                                    <div className={cx(Styles.imagesContainerItem, Styles.imagesContainerItemPlaceholder)}></div>
                                }
                            </div>
                            <div className={Styles.optionsContainerSectionTitle}>
                                {this.renders.text("item_3")}
                            </div>
                            <div className={Styles.optionsContainerItems}>
                                <div className={Styles.optionsContainerItemsPlus}>
                                    <div className={Styles.optionsContainerItemsPlusInner}>
                                        <div className={Styles.optionsContainerItemsPlusInnerPlus}>
                                            +
                                        </div>
                                    </div>
                                    {
                                        this.state.slides.length < 10 &&
                                        <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null} onChange={(e) => this.functions.uploadSlide(e)} type={"file"} accept={"image/jpeg, image/png"} className={Styles.optionsContainerItemsPlusInnerUpload}/>
                                    }
                                </div>
                                {
                                    this.state.slides.map((item) => {
                                        return(
                                            this.renders.slide(item)
                                        )
                                    })
                                }
                                {
                                    this.state.slides.map((item) => {
                                        return(
                                            <div className={cx(Styles.imagesContainerItem, Styles.imagesContainerItemPlaceholder)}></div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div onClick={() => this.functions.next()} className={
                            cx(Styles.button,
                                {
                                    [Styles.buttonActive]: true,
                                })
                        }>
                            {this.renders.text("item_7")}
                        </div>
                        <div onClick={() => this.functions.back()} className={cx(Styles.backButton)}>
                            {this.renders.text("item_4")}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SignUpThemeCustom;


// WEBPACK FOOTER //
// ./src/pages/signup-theme-custom/component.js